import type React from 'react';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { PageMessage } from '@change-corgi/design-system-legacy/components/alerts';
import { Card } from '@change-corgi/design-system-legacy/components/content';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import { useCTAButtonVariant } from 'src/app/pages/starterDashboardV2/shared/contexts';
// eslint-disable-next-line @change/sibling-module-imports
import { ShareVisualContent } from 'src/app/pages/starterDashboardV2/shared/hooks/useTriggerShareVisualModal/useShareVisualModal/components/ShareVisualModalBody/components/ShareVisualContent';

import { useDashboardReskinExperiment } from '../../../../../../hooks/useDashboardReskinExperiment';

// FIXME refactor needed to not import internal logic from the shared hooks

import { Loading } from './components/Loading';
import { useShareVisual } from './hooks/useShareVisual';
import { ShareVisual as ShareVisualReskin } from './index_new';

export const ShareVisual: React.FC = () => {
	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();
	const {
		data: { buttonDisabled, petition, shareVisualEnabled, shareVisualsState, shareVisualDownloaded, newModuleEnabled },
		actions,
	} = useShareVisual();
	const { translate } = useI18n();
	const { getCTAVariant } = useCTAButtonVariant();

	if (newModuleEnabled) return null;

	if (isEnabled) {
		return <ShareVisualReskin />;
	}

	if (!shareVisualEnabled) return null;

	if (shareVisualsState === 'loading') return <Loading />;

	if (shareVisualsState === 'timeout')
		return (
			<Card
				p="24px"
				backgroundColor="white"
				data-qa="grow-petition-share-visual-container"
				data-testid="grow-petition-share-visual-timeout-container"
				sx={{ border: 'unset', borderRadius: 'big' }}
			>
				<Text as="div" size="large" sx={{ textAlign: 'center' }}>
					<Translate value="corgi.petition.starter_dashboard.shared.share_visuals.modal_timeout_copy" />
				</Text>
			</Card>
		);

	return (
		<Card
			py="24px"
			px="16px"
			backgroundColor="white"
			data-qa="grow-petition-share-visual-container"
			data-testid="grow-petition-share-visual-loaded-container-control"
			sx={{ border: 'unset', borderRadius: 'big' }}
		>
			<Heading px="8px" as="h3" size="h4" id="share-petition-visuals-title" data-qa="share-petition-visuals-title">
				<Translate value="corgi.petition.starter_dashboard.grow_petition.share_visuals.title" />
			</Heading>
			<Text px="8px" as="p" mt="16px">
				<Translate value="corgi.petition.starter_dashboard.grow_petition.share_visuals.description" />
			</Text>
			<form
				onSubmit={actions.onShareVisualDownload}
				sx={{ display: 'flex', flexDirection: 'column', marginTop: 24 }}
				data-qa="share-visual-modal-form"
			>
				<ShareVisualContent
					petition={petition}
					context="starter_dashboard_grow_petition"
					onChange={actions.onShareVisualSelect}
				/>
				<Flex px="8px" sx={{ flexDirection: ['column', 'row', 'row'], gap: 16 }}>
					<Button
						variant={getCTAVariant('secondaryEmphasis')}
						type="submit"
						disabled={buttonDisabled}
						data-qa="share-visual-modal-download"
					>
						<Text breakWord>
							<Translate value="corgi.petition.starter_dashboard.shared.share_visuals.modal_action_button" />
						</Text>
					</Button>
				</Flex>
			</form>
			{shareVisualDownloaded && (
				<>
					<PageMessage
						mt={24}
						message={translate('corgi.petition.starter_dashboard.shared.share_visuals.downloaded_desktop')}
						severity="success"
						containerVariant="small"
						sx={{ borderRadius: '0.5rem', display: ['none', 'block'] }}
					/>
					<PageMessage
						mt={24}
						message={translate('corgi.petition.starter_dashboard.shared.share_visuals.downloaded_mobile')}
						severity="success"
						containerVariant="small"
						sx={{ borderRadius: '0.5rem', display: ['block', 'none'] }}
					/>
				</>
			)}
		</Card>
	);
};
